// import { ParsedQs } from 'qs';
import httpContext from '@rover/rsdk/src/modules/Network/httpContext';

export function getParams(queryParam: string): string[] | string | null {
  if (process.env.JS_ENV_CLIENT) {
    const params = new URL(window.location.href).searchParams;
    return params.getAll(queryParam);
  }

  const req = httpContext.getReq();
  if (!req?.query) return null;
  const params = req.query;
  const paramValue = queryParam in params ? params[queryParam] : null;
  return (paramValue || null) as string[] | string | null; // This should actually include ParsedQs, and ParsedQs[], but doing so causes an explosion of type errors
}

export default function getParam(queryParam: string): string | null {
  if (process.env.JS_ENV_CLIENT) {
    const params = new URL(window.location.href).searchParams;
    return params.get(queryParam);
  }

  const req = httpContext.getReq();
  if (!req?.query) return null;
  const params = req.query;
  const paramValue = queryParam in params ? params[queryParam] : null;
  return (paramValue || null) as string | null; // This should actually include string[], ParsedQs, and ParsedQs[], but doing so causes an explosion of type errors
}

export const getAllParams = (): URLSearchParams | null => {
  if (process.env.JS_ENV_CLIENT) {
    return new URL(window.location.href).searchParams;
  }

  const req = httpContext.getReq();
  if (!req) return null;
  const params = req.query;
  return new URLSearchParams(params as any);
};
